/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

//////////////////////////
// Contract permissions //
//////////////////////////
// Create Permissions //
////////////////////////
export const create: RoleList = [Roles.USER];

// Create Permissions > Request to extend specific contract
export const createRequestExtendContract: RoleList = [...create];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

// Update Permissions > Extend specific contract
export const updateExtendContract: RoleList = [...update];

// Update Permissions > Approve contract extension
export const updateApproveContractExtension: RoleList = [...update];

// Update Permissions > Decline contract extension
export const updateDeclineContractExtension: RoleList = [...update];

// Update Permissions > Download contract documents
export const updateDownloadContractDocs: RoleList = [Roles.USER, ...update];
